import { Assets } from "src/utils/assets";

export function AuthHeader() {
    return <div className="login-top mb20">   <div className="item logo"><img src={Assets.logoSide} alt="Liex" height={30} /></div>
    </div>
}